import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
import { getMeetingDuration } from '../selectors/getMeetingDuration';
import { getReminderTime } from '../selectors/getReminderTime';

/**
 * Returns true if there is a change in the event options
 */

export default function isEventOptionDirty(): boolean {
    let calendarConfiguration: MailboxCalendarConfiguration = getCalendarConfiguration();

    if (!calendarConfiguration) {
        return false;
    }

    return (
        getReminderTime() !== calendarConfiguration.DefaultReminderTime ||
        getMeetingDuration() !== calendarConfiguration.DefaultMeetingDuration
    );
}
